
// SVG Icon: ar-on
export default { id: "terriajs-ar-on" };
export const id = "terriajs-ar-on";
export const name = "ar-on";
